import axios from "axios";
import { environment } from "../../../environment";
import { errorLog } from "../../../logger";
import { parsePaginationHeaders } from "../../utils/parsePaginationHeaders";
import ValidationError from "../../ZodError";
import { PostMarketplaceOfferingsQueryBodyParams, PostMarketplaceOfferingsQueryResponse, } from "./Types";
export const clientMarketplaceOfferingsQueryUrl = () => environment() === "PROD"
    ? "https://middleware.prod.farther.com/alt-asset/v3/client/offering/query"
    : "https://middleware.uat.farther.com/alt-asset/v3/client/offering/query";
export default async function postClientMarketplaceOfferingsQuery(config, bodyParams) {
    const decodedBodyParams = PostMarketplaceOfferingsQueryBodyParams.safeParse(bodyParams);
    if (!decodedBodyParams.success) {
        errorLog(postClientMarketplaceOfferingsQuery.name, JSON.stringify(decodedBodyParams.error.issues));
        throw new ValidationError(`Validation failed for request body parameters [${postClientMarketplaceOfferingsQuery.name}]`, decodedBodyParams.error.issues);
    }
    const { data, headers } = await axios.post(clientMarketplaceOfferingsQueryUrl(), bodyParams, {
        headers: {
            Authorization: `Bearer ${config.jwt}`,
            Client: config.clientId,
            ...(config.advisorId && { Advisor: config.advisorId }),
        },
    });
    const decodedResponse = PostMarketplaceOfferingsQueryResponse.safeParse(data);
    if (decodedResponse.success) {
        return {
            values: decodedResponse.data.values,
            pagination: parsePaginationHeaders(headers),
        };
    }
    else {
        errorLog(postClientMarketplaceOfferingsQuery.name, JSON.stringify(decodedResponse.error.issues));
        throw new ValidationError(`[${postClientMarketplaceOfferingsQuery.name}] returned unexpected data.`, decodedResponse.error.issues);
    }
}
//# sourceMappingURL=postClientMarketplaceOfferingsQuery.js.map